import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import FontPropertySelect from '../../../common/FontPropertySelect';
import { getProperLinkStyles } from '../../../../utils/links';
import If from '../../../helpers/if';

class LinksPreviewWithStyles extends Component {
    render() {
        const { data, fontStyle, tagNameName, tag, isDisabled, onThemePropChange, layer, styleStates } = this.props;

        const isUnderline = !!data.underline;

        return (
            <div className="ButtonPreview">
                <h4>{tagNameName}</h4>
                <p>{tag}</p>
                <div className="row">
                    {styleStates.map((styleState, idx) => (
                        <div className="col-xs-12 col-sm-3" key={styleState + idx}>
                            <div className="text-center">
                                <span
                                    className="text-center"
                                    style={{
                                        color: data.color[styleState],
                                        fontSize: fontStyle.baseSize,
                                        fontStyle: 'normal',
                                        fontWeight: data.fontWeight,
                                        fontFamily: fontStyle.main,
                                        textTransform: 'uppercase',
                                        ...getProperLinkStyles(data, styleState)
                                    }}
                                >
                                    {styleState}
                                </span>
                            </div>
                            <div className="top-margin text-center">
                                Font Color
                                <PresetColorPicker
                                    color={data.color[styleState]}
                                    isDisabled={isDisabled}
                                    onColorChange={onThemePropChange(`${layer}.color.${styleState}`)}
                                />
                            </div>
                            {isUnderline && (
                                <div>
                                    <div className="top-margin">
                                        <FontPropertySelect
                                            label="Underline Width"
                                            defaultValue={data.underline[styleState].width}
                                            themeAccess={isDisabled}
                                            values={['0px', '1px', '2px', '3px', '4px']}
                                            onChange={onThemePropChange(`${layer}.underline.${styleState}.width`)}
                                        />
                                    </div>
                                    <div className="top-margin">
                                        <FontPropertySelect
                                            label="Underline Style"
                                            defaultValue={data.underline[styleState].style}
                                            themeAccess={isDisabled}
                                            values={['solid', 'dotted', 'dashed', 'double', 'none']}
                                            onChange={onThemePropChange(`${layer}.underline.${styleState}.style`)}
                                        />
                                    </div>
                                    <div className="top-margin text-center">
                                        Underline Color
                                        <PresetColorPicker
                                            color={data.underline[styleState].color}
                                            isDisabled={isDisabled}
                                            onColorChange={onThemePropChange(`${layer}.underline.${styleState}.color`)}
                                        />
                                    </div>
                                </div>
                            )}
                            {!isUnderline && (
                                <div className="top-margin">
                                    <FontPropertySelect
                                        label="Text Decoration"
                                        defaultValue={data.textDecoration[styleState]}
                                        themeAccess={isDisabled}
                                        values={['none', 'underline']}
                                        onChange={this.props.onThemePropChange(`${layer}.textDecoration.${styleState}`)}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-3 top-margin">
                        <FontPropertySelect
                            label="Font Weight"
                            defaultValue={data.fontWeight}
                            themeAccess={isDisabled}
                            values={['100', '200', '300', '400', '500', '600', '700', '800', '900']}
                            onChange={onThemePropChange(`${layer}.fontWeight`)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

LinksPreviewWithStyles.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object,
    tag: PropTypes.string,
    isDisabled: PropTypes.bool
};

const mapDispatchToProps = dispatch => {
    return {
        onThemePropChange: onThemePropChange(dispatch, '')
    };
};

export default connect(null, mapDispatchToProps)(LinksPreviewWithStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/LinksPreviewWithStyles.js